import { Component, Inject, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../services/spinner.service';
import { SnackbarService } from '../../services/snackbar.service';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { AcuerdoAmbitoGeograficoFilterDTO, AcuerdoIndirectoControllerService, AcuerdoAmbitoGeograficoControllerService } from 'api-rest';
import { ApiAcuerdosGestores } from 'api-rest';
import swal from 'sweetalert2';
import { Validators, FormBuilder, FormGroup, ValidatorFn, ValidationErrors, AbstractControl, FormControl,
 } from '@angular/forms';
import { ValidateService } from '../../services/validate.service';
import { Combo } from '../../models/combo';
import { ComboService } from '../../services/combo.service';

const ESTADO_PENDIENTE = 1;
const PENDIENTE_GENERAR_ACUERDO = 2;
const MENU_DATOS_GENERALES = 1;
const MENU_GESTORES_ACUERDO = 2;
const MENU_DATOS_CONTACTO = 3;
const MENU_DIRECCIONES = 4;
const MENU_PREVISION_RESIDUOS = 5;
const MENU_AMBITO_GEOGRAFICO = 6;
const MENU_POSEEDORES_CON_ACUERDO = 7;
const MENU_DOCUMENTOS = 8;
const ESTADO_BAJA = 6;

@Component({
  selector: 'managers-agreements-indirect-agreement-detail',
  templateUrl: './indirect-agreement-detail.component.html',
  styleUrls: ['./indirect-agreement-detail.component.scss'],
})
export class IndirectAgreementDetailComponent implements OnInit {
  selectedMenu = 1;
  lastMenu = 1;
  acuerdoInfo: any;
  acuerdoIndirectoInfo: any = null;
  datosCargados = false;
  textoEstado = '';
  pageNumber: number = 0;
  pageSize: number = 25;
  datosGeneralesForm: FormGroup;
  tiposDocumento: Combo[] = [];
  canEditAllAgreementData = false;
  canEditOnlyPoseedoresAndDocuments = false;
  private filtrosBusqueda: any = null;
  poseedoresEndpoint = 
    this.environment.urlBackPoseedores + `api/v1/poseedores/poseedor`;
  poseedoresAcuerdoGrid: any[] = [];
  poseedorSeleccionado: any = null;
  poseedorControl: FormControl = new FormControl(null);
  poseedoresAcuerdoHeadArray: any = [
    {
      Head: 'ID poseedor',
      FieldName: 'poseedor',
      Attribute: 'id',
    },
    {
      Head: 'NIMA',
      FieldName: 'poseedor',
      Attribute: 'nima',
    },
    {
      Head: 'Razón social',
      FieldName: 'poseedor',
      Attribute: 'razonSocial',
      Tooltip: true,
    },
    {
      Head: 'Estado',
      FieldName: 'estado',
      Attribute: 'descripcion',
    },
    {
      Head: 'Fecha firma acuerdo',
      FieldName: 'fechaFirmaAcuerdo',
    },
  ];
  

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    @Inject('environment') private environment: any,
    @Inject('EmpusaAuthenticationService')
    private authService: EmpusaAuthenticationService,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private acuerdoIndirectoControllerSrv: AcuerdoIndirectoControllerService,
    private acuerdoAmbitoGeograficoControllerSrv: AcuerdoAmbitoGeograficoControllerService,
    private poseedoresAcuerdoControllerSrv: ApiAcuerdosGestores.PoseedoresAcuerdoControllerService,
    private formBuilder: FormBuilder,
    private validateSrv: ValidateService,
    private comboSrv: ComboService,
  ) {
        console.log('this.acuerdoInfo', this.acuerdoInfo);
    const state = this.router.getCurrentNavigation()?.extras.state ??
      window.history.state;
    const acuerdo = state?.acuerdo;
    this.filtrosBusqueda = state?.filtros ?? null;
    if (acuerdo) {
      this.setAgreementData(acuerdo);
    } else {
      const acuerdoIdFromQuery = Number(this.route.snapshot.queryParamMap.get('acuerdoId'));
      if (Number.isFinite(acuerdoIdFromQuery) && acuerdoIdFromQuery > 0) {
        this.acuerdoInfo = { id: acuerdoIdFromQuery };
      } else {
        this.snackBarSrv.showSnackBar(
          'No se encontró el acuerdo indirecto',
          'error'
        );
        this.router.navigate(['/managers-agreements/indirect-agreement-search']);
      }
    }

    this.datosGeneralesForm = this.formBuilder.group({
      tipoDocumento: [
        { value: this.acuerdoInfo?.tipoDocumento ?? null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      codigoDocumento: [
        { value: this.acuerdoInfo?.codigoDocumento ?? null, disabled: false },
        { validators: Validators.compose([Validators.required, this.documentoValidator()]) },
      ],
      razonSocial: [
        { value: this.acuerdoInfo?.razonSocial ?? null, disabled: false },
        { validators: Validators.compose([Validators.required, Validators.maxLength(150)]) },
      ],
    })

  }

  ngOnInit(): void {

    this.canEditAllAgreementData = this.canViewResource('AI-ENV-GEST');
    this.canEditOnlyPoseedoresAndDocuments = !this.canEditAllAgreementData && this.canViewResource('AI-GESTOR');

    if (!this.canEditGeneralSections()) {
      this.datosGeneralesForm.disable({ emitEvent: false });
    }

    
    this.tiposDocumento = this.comboSrv.getTiposDocumentoIdentidad();

    this.datosGeneralesForm.get('tipoDocumento')?.valueChanges.subscribe(() => {
      this.datosGeneralesForm.get('codigoDocumento')?.updateValueAndValidity();
    });

    const initialAgreementId = Number(this.route.snapshot.queryParamMap.get('acuerdoId'));
    if (!this.datosCargados && Number.isFinite(initialAgreementId) && initialAgreementId > 0) {
      this.loadAgreementById(initialAgreementId);
    }

    this.route.queryParamMap.subscribe((params) => {
      const acuerdoId = Number(params.get('acuerdoId'));
      if (!Number.isFinite(acuerdoId) || acuerdoId <= 0 || this.acuerdoInfo?.id === acuerdoId) {
        return;
      }
      this.loadAgreementById(acuerdoId);
    });

    //this.loadPoseedoresAcuerdo();



  }
  
    ngOnChanges(changes: SimpleChanges): void {
              console.log('this.acuerdoInfo', this.acuerdoInfo);
      if (this.acuerdoInfo) {
        console.log('this.acuerdoInfo', this.acuerdoInfo);
        this.controlGeneralForm();
      }
  
    }
  get styleEstado() {
    switch (this.acuerdoIndirectoInfo?.estado?.id) {
      case 5:
        return { 'background-color': '#86BC25', 'color': '#ffffff' };
      case 7:
        return { 'background-color': '#ffffff', 'color': '#080C35' };
      case 9:
        return { 'background-color': '#A7A6A6', 'color': '#ffffff' };
      case 8:
        return { 'background-color': '#080C35  ', 'color': '#ffffff' };
      case 1:
        return { 'background-color': '#F49D33', 'color': '#ffffff' };
      case 2:
        return { 'background-color': '#004A99  ', 'color': '#ffffff' };
      case 3:
        return { 'background-color': '#B80F61 ', 'color': '#ffffff' };
      case 4:
        return { 'background-color': '#773E90', 'color': '#ffffff' };
      case 0:
        return { 'background-color': '#F49D33', 'color': '#ffffff' };
      case 10:
        return { 'background-color': '#5FC3E1  ', 'color': '#ffffff' };
      case 6:
        return { 'background-color': '#ffffff  ', 'color': '#080C35' };
      default:
        return { 'background-color': '#ffffff', 'color': '#ffffff' };
    }
  }
  get iconEstado() { 
    return this.acuerdoIndirectoInfo?.estado?.id === 6 ? 'check_circle' : 'warning_amber'; }

  loadNumMenu(num: number): void {
    this.selectedMenu = num;
    if (this.lastMenu < num) {
      this.lastMenu = num;
    }
  }

  mensajeValidacion(): void {
    this.snackBarSrv.showSnackBar(
      'Para poder desplazarse de una pantalla a otra deberá hacerlo mediante los botones de la parte inferior.'
    );
  }

  private esWizardActivo(): boolean {
    return this.acuerdoIndirectoInfo?.estado?.id === ESTADO_PENDIENTE;
  }

  anterior(): void {
    if (this.selectedMenu - 1 > 0) {
      this.selectedMenu = this.selectedMenu - 1;
    }
  }

  siguiente(): void {
    if (this.selectedMenu + 1 <= MENU_DOCUMENTOS) {
      this.loadNumMenu(this.selectedMenu + 1);
    }
  }

  canAccessAnteriorAll(menu: number): boolean {
    if (!this.canEditGeneralSections()) {
      return false;
    }
    return (menu === MENU_DATOS_CONTACTO || menu === MENU_GESTORES_ACUERDO|| menu === MENU_DIRECCIONES || menu === MENU_PREVISION_RESIDUOS || menu === MENU_AMBITO_GEOGRAFICO || menu === MENU_POSEEDORES_CON_ACUERDO) && this.esWizardActivo();
  }

  canAccessContinuarAll(menu?: number): boolean {
    if (!this.canEditGeneralSections()) {
      return false;
    }
    return (menu === MENU_DATOS_GENERALES || menu === MENU_GESTORES_ACUERDO || menu === MENU_DATOS_CONTACTO || menu === MENU_PREVISION_RESIDUOS || menu === MENU_DIRECCIONES || menu === MENU_POSEEDORES_CON_ACUERDO ) && this.esWizardActivo();
  }

  canAccessGuardar(menu?: number): boolean {
    return this.canEditGeneralSections() && menu === MENU_DATOS_GENERALES && !this.esWizardActivo() && this.acuerdoIndirectoInfo?.estado?.id !== ESTADO_BAJA;
  }

  canAccessFinalizar(menu: number): boolean {
    return this.canEditGeneralSections() && menu === MENU_AMBITO_GEOGRAFICO && this.esWizardActivo();
  }

  canAccessCancelar(): boolean {
    return this.canEditGeneralSections() && this.selectedMenu <= MENU_DOCUMENTOS && this.esWizardActivo();
  }

  canAccessVolver(): boolean {
    return true;
  }

  continuarName(menu: number): string {
    switch (menu) {
      case MENU_DATOS_GENERALES:
        return this.canAccessContinuarAll(menu) ? 'Guardar y Continuar' : 'Guardar';
      case MENU_GESTORES_ACUERDO:
        return this.canAccessContinuarAll(menu) ? 'Continuar' : '';
      case MENU_DATOS_CONTACTO:
        return this.canAccessContinuarAll(menu) ? 'Continuar' : '';
      case MENU_DIRECCIONES:
        return this.canAccessContinuarAll(menu) ? 'Continuar' : '';
      case MENU_PREVISION_RESIDUOS:
        return this.canAccessContinuarAll(menu) ? 'Continuar' : '';
        //     case MENU_AMBITO_GEOGRAFICO:
        // return this.canAccessContinuarAll(menu) ? 'Continuar' : '';
        //             case MENU_POSEEDORES_CON_ACUERDO:
        // return this.canAccessContinuarAll(menu) ? 'Continuar' : '';
      default:
        return '';
    }
  }

  controlAccionsWizard(idMenu: number): void {
    if (!this.canEditGeneralSections()) {
      this.snackBarSrv.showSnackBar(
        'No dispone de permisos para editar esta sección',
        'error'
      );
      return;
    }

    switch (idMenu) {
      case MENU_DATOS_GENERALES:
        if(this.verificarDatosGeneralesObligatorios()) {
          this.snackBarSrv.showSnackBar(
            'Debe completar los datos en los campos requeridos',
            'error'
          );
        } else {
          const acuerdoUpdate: any = { ...this.acuerdoInfo};
          acuerdoUpdate.tipoDocumento = this.datosGeneralesForm.get('tipoDocumento')?.value;
          acuerdoUpdate.codigoDocumento = this.datosGeneralesForm.get('codigoDocumento')?.value;
          acuerdoUpdate.razonSocial = this.datosGeneralesForm.get('razonSocial')?.value;
          this.spinnerSrv.loadingShow();
          this.acuerdoIndirectoControllerSrv.updateById(this.acuerdoInfo.id, acuerdoUpdate).subscribe({
            next: (data: any) => {
              this.snackBarSrv.showSnackBar(
                'Se han guardado los datos correctamente',
                'success'
              );
              this.spinnerSrv.loadingHide();
              this.refrescar();
              this.siguiente();
            }
          });
        }
        break;
      case MENU_GESTORES_ACUERDO:
        if (!this.tieneAlMenosUnGestor()) {
          this.snackBarSrv.showSnackBar(
            'Debe registrar al menos un gestor del acuerdo',
            'error'
          );
        } else {
          this.siguiente();
        }
        break;
      case MENU_DATOS_CONTACTO:
        if (!this.tieneAlMenosUnContacto()) {
          this.snackBarSrv.showSnackBar(
            'Debe registrar al menos un dato de contacto',
            'error'
          );
        } else if (this.verificarObligatorioContactos()) {
          this.snackBarSrv.showSnackBar(
            'Debe completar los datos en los contactos requeridos',
            'error'
          );
        } else {
          this.siguiente();
        }
        break;
      case MENU_DIRECCIONES:
        if (this.verificarObligatorioDirecciones()) {
          this.snackBarSrv.showSnackBar(
            'Debe completar los datos en las direcciones requeridas',
            'error'
          );
        } else {
          this.siguiente();
        }
        break;
      case MENU_PREVISION_RESIDUOS:
        this.siguiente();
        break;
      case MENU_AMBITO_GEOGRAFICO:
        this.spinnerSrv.loadingShow();
        this.verificarObligatorioAmbitoGeografico().subscribe({
          next: (data: any) => {
            const totalElements = data.paginacion?.totalElements ?? data.datos?.length ?? 0;
            this.spinnerSrv.loadingHide();
            if (totalElements === 0) {
              this.snackBarSrv.showSnackBar('Debe registrar al menos un ámbito geográfico', 'error');
              return;
            }
            this.siguiente();
          },
          error: () => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar('Ha ocurrido un error al comprobar el ámbito geográfico', 'error');
          },
        });
        break;
      case MENU_DOCUMENTOS:
        this.siguiente();
        break;
      default:
        break;
    }
  }

  verificarObligatorioContactos() {
    const objetoCampoObligatorios = {
      tipoContacto: true,
      persona: true,
      nombre: true,
      apellido1: false,
      tipo_documento: false,
      codigo_documento: false,
      tipo_telefono: true,
      prefijoPais: true,
      numero_telefono: true,
      email: true,
      recibir_comunicaciones: true,
      recibir_comunicaciones_contrato: true,
      acreditacion_poderes: false,
    };

    if (this.acuerdoIndirectoInfo.contactos.length != 0) {
      const tieneCamposObligatoriosVacios = this.acuerdoIndirectoInfo.contactos
        .filter((objeto: any) => objeto.requerido)
        .map((item: any) => {
          if (item?.tipo_contacto.id === 3 || item?.tipo_contacto.id === 4) {
            objetoCampoObligatorios.tipo_documento = true;
            objetoCampoObligatorios.codigo_documento = true;
            objetoCampoObligatorios.acreditacion_poderes = true;
          } else {
            objetoCampoObligatorios.tipo_documento = false;
            objetoCampoObligatorios.codigo_documento = false;
            objetoCampoObligatorios.acreditacion_poderes = false;
          }
          if (item?.persona) {
            objetoCampoObligatorios.apellido1 = true;
          } else {
            objetoCampoObligatorios.apellido1 = false;
          }
          const data = Object.entries(objetoCampoObligatorios).some(
            ([campo, obligatorio]) =>
              obligatorio && (item[campo] === '' || item[campo] === null)
          );
          return data;
        })
        .some((resultado: any) => resultado);
      return tieneCamposObligatoriosVacios;
    } else {
      return false;
    }
  }

  tieneAlMenosUnContacto(): boolean {
    const contactos = this.acuerdoIndirectoInfo?.contactos ?? [];
    return contactos.length > 0;
  }

  verificarObligatorioDirecciones(): boolean {
    const objetoCampoObligatorios = {
      provincia: false,
      codigoPostal: false,
      municipio: false,
      tipoDireccion: false,
      tipoVia: false,
      nombreVia: false,
      numero: false,
      pais: true,
    };

    const domicilios = this.acuerdoIndirectoInfo?.domicilios ?? [];
    if (domicilios.length === 0) {
      return false;
    }

    return domicilios
      .filter((objeto: any) => objeto.requerido)
      .map((item: any) => {
        if (item.pais?.id === 69) {
          objetoCampoObligatorios.provincia = true;
          objetoCampoObligatorios.codigoPostal = true;
          objetoCampoObligatorios.municipio = true;
          objetoCampoObligatorios.nombreVia = true;
          objetoCampoObligatorios.numero = true;
        } else {
          objetoCampoObligatorios.provincia = false;
          objetoCampoObligatorios.codigoPostal = false;
          objetoCampoObligatorios.municipio = false;
          objetoCampoObligatorios.nombreVia = false;
          objetoCampoObligatorios.numero = false;
        }
        return Object.entries(objetoCampoObligatorios).some(
          ([campo, obligatorio]) =>
            obligatorio && (item[campo] === '' || item[campo] == null)
        );
      })
      .some((resultado: any) => resultado);
  }

finalizar(): void {

  this.spinnerSrv.loadingShow();
  this.verificarObligatorioAmbitoGeografico().subscribe({
    next: (data : any) => {
      const totalElements = data.paginacion?.totalElements ?? data.datos?.length ?? 0;
      if (totalElements === 0) {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Debe registrar al menos un ámbito geográfico', 'error');
        return;
      }
      this.finalizarAcuerdo(); 
    },
    error: () => {
      this.spinnerSrv.loadingHide();
      this.snackBarSrv.showSnackBar('Ha ocurrido un error al comprobar el ámbito geográfico', 'error');
    },
  });
}

  buttonVolver(): void {
    this.router.navigate(['/managers-agreements/indirect-agreement-search'], {
      state: { filtros: this.filtrosBusqueda },
    });
  }

  buttonCancelar(): void {
    swal
      .fire({
        text: '¿Desea cancelar esta acción?. Regresará al buscador.',
        icon: 'question',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Sí',
        denyButtonText: 'No',
        allowOutsideClick: false,
      })
      .then((result: any) => {
        if (result.isConfirmed) {
          this.router.navigate(['/managers-agreements/indirect-agreement-search']);
        }
      });
  }

  canViewResource(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

  canEditGeneralSections(): boolean {
    return this.canEditAllAgreementData && this.acuerdoIndirectoInfo?.estado?.id !== ESTADO_BAJA;
  }

  canEditPoseedoresSection(): boolean {
    return this.canEditAllAgreementData || this.canEditOnlyPoseedoresAndDocuments;
  }

  canUploadDocumentSection(): boolean {
    return (this.canEditAllAgreementData || this.canEditOnlyPoseedoresAndDocuments) && this.acuerdoIndirectoInfo?.estado?.id !== ESTADO_BAJA;
  }

  canDeleteDocumentSection(): boolean {
    return this.canEditAllAgreementData && this.acuerdoIndirectoInfo?.estado?.id !== ESTADO_BAJA;
  }

refrescar(): void {

    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    const filtro: any = {
        id: this.acuerdoInfo.id,
    };
    
  this.acuerdoIndirectoControllerSrv.findAll3(filtro, { page: page, size: this.pageSize, sort: [] }).subscribe(acuerdo => {
    this.acuerdoInfo = acuerdo.datos?.[0] ?? this.acuerdoInfo;
    this.acuerdoIndirectoInfo = this.buildAcuerdoDirectoInfo();
    
    //this.loadPoseedoresAcuerdo();
  });
}

  loadPoseedoresAcuerdo(): void {
    if (!this.acuerdoInfo?.id) {
      this.poseedoresAcuerdoGrid = [];
      return;
    }

    const gestorAcuerdo = this.acuerdoInfo?.gestoresResiduos?.[0] ?? this.acuerdoInfo?.gestor;
    const filtro: ApiAcuerdosGestores.PoseedoresAcuerdoFilterDTO = {
      gestores: gestorAcuerdo?.id ? [{ id: gestorAcuerdo.id } as any] : undefined,
    };

    this.spinnerSrv.loadingShow();
    this.poseedoresAcuerdoControllerSrv
      .findAll(filtro, { page: 0, size: 200, sort: ['id,desc'] })
      .subscribe({
        next: (data: any) => {
          this.spinnerSrv.loadingHide();
          const rows = data?.datos ?? [];
          this.poseedoresAcuerdoGrid = rows.filter(
            (item: any) => item?.acuerdoIndirecto?.id === this.acuerdoInfo?.id
          );
        },
        error: () => {
          this.spinnerSrv.loadingHide();
          this.poseedoresAcuerdoGrid = [];
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al obtener los poseedores con acuerdo',
            'error'
          );
        },
      });
  }

  addPoseedorToAgreement(): void {
    if (!this.canEditPoseedoresSection()) {
      this.snackBarSrv.showSnackBar('No dispone de permisos para editar poseedores', 'error');
      return;
    }

    if (!this.acuerdoInfo?.id || !this.poseedorSeleccionado?.id) {
      this.snackBarSrv.showSnackBar('Debe seleccionar un poseedor', 'error');
      return;
    }

    const alreadyIncluded = this.poseedoresAcuerdoGrid.some(
      (item: any) => item?.poseedor?.id === this.poseedorSeleccionado?.id
    );
    if (alreadyIncluded) {
      this.snackBarSrv.showSnackBar('El poseedor seleccionado ya está incluido en el acuerdo', 'warning');
      return;
    }

    const gestorAcuerdo = this.acuerdoInfo?.gestoresResiduos?.[0] ?? this.acuerdoInfo?.gestor;
    if (!gestorAcuerdo?.id) {
      this.snackBarSrv.showSnackBar('No se pudo determinar el gestor asociado al acuerdo', 'error');
      return;
    }

    const payload: ApiAcuerdosGestores.PoseedoresAcuerdoCreatePayloadDTO = {
      acuerdoIndirecto: { id: this.acuerdoInfo.id } as any,
      gestor: { id: gestorAcuerdo.id } as any,
      poseedor: { id: this.poseedorSeleccionado.id } as any,
    };

    this.spinnerSrv.loadingShow();
    this.poseedoresAcuerdoControllerSrv.create(payload).subscribe({
      next: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Poseedor añadido al acuerdo correctamente', 'success');
        this.poseedorSeleccionado = null;
        this.poseedorControl.setValue(null);
        //this.loadPoseedoresAcuerdo();
      },
      error: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Ha ocurrido un error al añadir el poseedor al acuerdo', 'error');
      },
    });
  }

  getPoseedorDescription(poseedor: any): string {
    return [poseedor?.razonSocial, poseedor?.nima].filter(Boolean).join(' - ');
  }

  getObjectQuery(searchterm: string) {
    return {
      descripcion: searchterm,
    };
  }

  onPoseedorSelected(poseedor: any): void {
    this.poseedorSeleccionado = poseedor;
  }

  private buildAcuerdoDirectoInfo(): any {
    if (!this.acuerdoInfo) return null;
    return {
      id: this.acuerdoInfo.id,
      codigoDocumento : this.acuerdoInfo.codigoDocumento,
      gestoresResiduos: [ ...this.acuerdoInfo.gestoresResiduos ],
      contactos: this.acuerdoInfo.contactos,
      domicilios: this.acuerdoInfo.domicilios,
      razonSocial: this.acuerdoInfo.razonSocial,
      estado: this.acuerdoInfo.gestoresResiduosDTO?.gestoresResiduosEstado
        ?? this.acuerdoInfo.estado
        ?? { id: 0 },
    };
  }

  private setAgreementData(acuerdo: any): void {
    this.acuerdoInfo = acuerdo;
    this.textoEstado = acuerdo?.estado?.descripcion ?? '';
    this.datosCargados = true;
    this.acuerdoIndirectoInfo = this.buildAcuerdoDirectoInfo();

    if (this.datosGeneralesForm) {
      this.datosGeneralesForm.patchValue(
        {
          tipoDocumento: this.acuerdoInfo?.tipoDocumento ?? null,
          codigoDocumento: this.acuerdoInfo?.codigoDocumento ?? null,
          razonSocial: this.acuerdoInfo?.razonSocial ?? null,
        },
        { emitEvent: false }
      );
      this.controlGeneralForm();
    }
  }

  private loadAgreementById(acuerdoId: number): void {
    const filtro: any = {
      id: [acuerdoId],
    };

    this.spinnerSrv.loadingShow();
    this.acuerdoIndirectoControllerSrv.findAll3(filtro, { page: 0, size: 1, sort: [] }).subscribe({
      next: (res: any) => {
        this.spinnerSrv.loadingHide();
        const acuerdo = res?.datos?.[0];
        if (acuerdo) {
          this.setAgreementData(acuerdo);
        } else {
          this.snackBarSrv.showSnackBar('No se encontró el acuerdo indirecto', 'error');
        }
      },
      error: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Ha ocurrido un error al cargar el acuerdo indirecto', 'error');
      },
    });
  }

verificarObligatorioAmbitoGeografico() {
  const filtro: AcuerdoAmbitoGeograficoFilterDTO = {
    acuerdoIndirecto: { id: this.acuerdoIndirectoInfo?.id },
  };
  return this.acuerdoAmbitoGeograficoControllerSrv
    .findAll5(filtro, { page: 0, size: 1, sort: [] });
}

  verificarDatosGeneralesObligatorios(): boolean {
    return this.datosGeneralesForm.invalid;
    // const objetoCampoObligatorios = {
    //   tipoDocumento: true,
    //   codigoDocumento: true,
    //   razonSocial: true,
    // };

    // return Object.entries(objetoCampoObligatorios).some(([campo, obligatorio]) => {

    //   console.log(`Verificando campo: ${campo}, obligatorio: ${obligatorio}, valor: ${this.acuerdoInfo[campo]}`);
    //   return obligatorio &&
    //     (
    //       this.acuerdoInfo[campo] == null ||
    //       (typeof this.acuerdoInfo[campo] === 'string' &&
    //         this.acuerdoInfo[campo].trim() === '')
    //     );
    // });
  }

  finalizarAcuerdo(): void {
    const acuerdoUpdate: any = { ...this.acuerdoInfo};
    acuerdoUpdate.estado = { 
      id: PENDIENTE_GENERAR_ACUERDO,
      descripcionCorta: 'Pdte de generar Acuerdo',
      descripcion: 'Pendiente Generar Acuerdo'
    };
    this.spinnerSrv.loadingShow();
    this.acuerdoIndirectoControllerSrv.updateById(acuerdoUpdate.id, acuerdoUpdate).subscribe({
      next: (data: any) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('El acuerdo indirecto ha sido finalizado correctamente', 'success');
        this.router.navigate(['/managers-agreements/indirect-agreement-search']);
        this.spinnerSrv.loadingHide();
      }
      ,
      error: (error: any) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Ha ocurrido un error al finalizar el acuerdo indirecto', 'error');
        console.error('Error al finalizar el acuerdo indirecto:', error);
      }
    });
  }

    documentoValidator(): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value) {
          return null;
        }
        const tipoDocumento = this.datosGeneralesForm?.get('tipoDocumento')?.value;
        let pattern: string | undefined;
        switch (tipoDocumento) {
          case 'NIF':
            pattern = this.validateSrv.nifPattern;
            break;
          case 'DNI':
            pattern = this.validateSrv.dniPattern;
            break;
          case 'NIE':
            pattern = this.validateSrv.niePattern;
            break;
          default:
            return null;
        }
        const regex = new RegExp(`^(${pattern})$`);
        return regex.test(value.toUpperCase()) ? null : { invalidFormat: true };
      };
    }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.datosGeneralesForm.controls[controlName].hasError(errorName) &&
      this.datosGeneralesForm.controls[controlName].touched
    );
  }

   tipoDocumentoSel(idTipoDoc: string) {
    this.datosGeneralesForm.get('codigoDocumento')?.clearValidators();
    if (idTipoDoc === 'NIF') {
      this.datosGeneralesForm
        .get('codigoDocumento')
        ?.setValidators([
          Validators.required,
          Validators.pattern(this.validateSrv.nifPattern),
        ]);
    } else if (idTipoDoc === 'DNI') {
      this.datosGeneralesForm
        .get('codigoDocumento')
        ?.setValidators([
          Validators.required,
          Validators.pattern(this.validateSrv.dniPattern),
        ]);
    } else if (idTipoDoc === 'NIE') {
      this.datosGeneralesForm
        .get('codigoDocumento')
        ?.setValidators([
          Validators.required,
          Validators.pattern(this.validateSrv.niePattern),
        ]);
    }
    this.datosGeneralesForm.get('codigoDocumento')?.updateValueAndValidity();
    this.datosGeneralesForm.get('codigoDocumento')?.markAsTouched();
  }
    controlFormDisable() {
    this.datosGeneralesForm.disable();
  }

  controlFormEnable() {
    this.datosGeneralesForm.enable();
  }
  controlGeneralForm() {
    if (this.canAccessContinuarAll() || this.canAccessGuardar()) {
      this.controlFormEnable();

    } else {
      this.controlFormDisable();
    }
  }

  tieneAlMenosUnGestor(): boolean {
  const gestores = this.acuerdoIndirectoInfo?.gestoresResiduos ?? [];
  return gestores.length > 0;
}
  }
